<template>
  <b-container fluid>
    <!-- Tab -->
    <b-row>
      <b-col md="12">
        <iq-card
          class="iq-card-block iq-card-stretch iq-card-height text-center"
        >
          <template>
            <div class="btn-group w-100">
              <button
                type="button"
                @click="viewMenu = 'plan'"
                @mouseover="tabMenuOptions.plan.isHover = true"
                @mouseleave="tabMenuOptions.plan.isHover = false"
                class="btn btn-outline-primary p-3 btn-menu"
                :class="{ 'btn-menu-active': viewMenu === 'plan' }"
              >
                PLAN MAINTENANCE
                <MaintenanceListIcon
                  :color="
                    tabMenuOptions.plan.isHover || viewMenu === 'plan'
                      ? 'white'
                      : '#0088AF'
                  "
                  class="ml-2"
                />
              </button>
              <button
                type="button"
                @click="viewMenu = 'history'"
                @mouseover="tabMenuOptions.history.isHover = true"
                @mouseleave="tabMenuOptions.history.isHover = false"
                class="btn btn-outline-primary p-3 btn-menu"
                :class="{ 'btn-menu-active': viewMenu === 'history' }"
              >
                MAINTENANCE HISTORY
                <MaintenanceHistoryIcon
                  :color="
                    tabMenuOptions.history.isHover || viewMenu === 'history'
                      ? 'white'
                      : '#0088AF'
                  "
                  class="ml-2"
                />
              </button>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col md="12">
        <template v-if="viewMenu === 'plan'">
          <MaintenancePlan />
        </template>
        <template v-if="viewMenu === 'history'">
          <MaintenanceHistoryNew />
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { xray } from '../../config/pluginInit'
import MaintenanceListIcon from './Components/Icons/MaintenanceListIcon.vue'
import MaintenanceHistoryIcon from './Components/Icons/MaintenanceHistoryIcon.vue'
import MaintenancePlan from './Components/Tabs/MaintenancePlan.vue'
import MaintenanceHistoryNew from './Components/Tabs/MaintenanceHistoryNew.vue'

export default {
  name: 'MaintenanceSummary',
  components: {
    MaintenanceListIcon,
    MaintenanceHistoryIcon,
    MaintenancePlan,
    MaintenanceHistoryNew,
  },
  mounted() {
    xray.index()
  },
  data() {
    return {
      viewMenu: 'plan',
      tabMenuOptions: {
        plan: {
          isHover: false,
          isActive: false,
        },
        history: {
          isHover: false,
          isActive: false,
        },
      },
    }
  },
}
</script>

<style scoped>
.icon-state-default {
  color: gray;
}
.icon-state-danger {
  color: red;
}
.icon-state-warning {
  color: yellow;
}
.icon-state-success {
  color: green;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}

.btn-menu:hover {
  background: #334697 !important;
  border: #334697;
}

.btn-menu-active {
  background: #334697 !important;
  color: white !important;
}
</style>
